export default {
    plotOptions: {
        line: {
            marker: {
                radius: 0,
                states: {
                    hover: {
                        radiusPlus: 5
                    }
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/temperature-preview.js